import { Button, Container, Form, Image } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux";

import logo from "../../imgs/gcash/logo_gcash.png";
import gcash_send from "../../imgs/gcash/image.png";
import { getGCashAccountsList, getGcashAddTransData, getGcashAddTransMessage } from "../../store/secure/selector";
import { getAccessToken, getUserData } from "../../store/auth/selector";
import * as secureActions from "../../store/secure/actions";
import "./style.scss"
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router";
import { useTranslation, Trans } from "react-i18next";
import { getAppInfo, getGateConf } from "../../store/app/selector";
import NumberFormat from "react-number-format";
import { getGateSC } from "../../config";


const Gcash = () => {
    const [transid, setTransid] = useState("")
    const appInfo = useSelector(state => getAppInfo(state))
    const access_token = useSelector(state => getAccessToken(state, appInfo))

    const accountsList = useSelector(state => getGCashAccountsList(state));
    // const accountsList = [];

    const addGcashTransMessage = useSelector(state => getGcashAddTransMessage(state));
    const addGcashTransData = useSelector(state => getGcashAddTransData(state));

    const userData = useSelector(state => getUserData(state, appInfo));
    const gateConf = useSelector(state => getGateConf(state))

    const { price } = useParams()
    const dispath = useDispatch();

    function copyToClipboard(e, text) {
        const el = document.createElement('textarea');
        el.value = text;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    };


    useEffect(() => {
        dispath(secureActions.getGcashAccountLists(access_token, userData.vip, userData.ref, appInfo, gateConf.apiUrl))
    }, [])

    const onRefChange = (event) => {
        setTransid(event.target.value)
    }

    const onAddTransaction = useCallback(() => {
        dispath(secureActions.gcashAddTransaction(access_token, transid, appInfo, gateConf.apiUrl))

    })

    const { t } = useTranslation('translations');
    return (
        <>
            <Container id="gcash">
                <div className="header">
                    <Image alt="" src={logo} />
                </div>
                <div className="title">
                    <Trans
                        i18nKey={'txt9'}
                        ns="translations"
                        values={{ userid: userData.userid }}
                        components={{
                            price: <NumberFormat
                                displayType={'text'}
                                value={price}
                                suffix={'₱'}
                                thousandSeparator={true}
                                disabled
                            />,
                            userid: <span />
                        }}
                    />
                </div>

                <div className="guide">
                    <div className="scanqr">
                        <div className="title">{t('txt10')}</div>
                        <div className="qrs">
                            {
                                accountsList.map((item, index) => {
                                    return (
                                        <div className="item" key={item + index}>
                                            {
                                                item && <><div className="qrimg">
                                                    <Image src={"https://cdnphpgames.com/api/public/dl/JZd6qPc5/gg/" + getGateSC(appInfo.gate) + "/gcash/qr/" + item.nummber + "/" + price + ".jpg"} />
                                                </div>
                                                    <div className="details">
                                                        <div className="info">
                                                            <div className="number">Number: {item.nummber}</div>
                                                            <div className="name">Name: {item.name}</div>
                                                        </div>

                                                        <div className="copy" onClick={(e) => copyToClipboard(e, item.nummber)}></div>
                                                    </div></>
                                            }


                                        </div>
                                    )
                                })
                            }

                        </div>
                    </div>
                    <div className="send">
                        <div className="title">{t('txt11')}</div>
                        <div className="details">
                            <div className="left">
                                <div className="ref">
                                    <div className="id rounded">{userData.userid} ID</div>
                                    <div className="copy" onClick={(e) => copyToClipboard(e, userData.userid + " ID")}></div>

                                </div>
                                <div className="arrow"></div>
                            </div>
                            <div className="right">
                                <img src={gcash_send} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="getchip">
                        {t('txt12')}
                    </div>
                </div>

                <div className="form">
                    <div className="note red">{t('txt13')}</div>
                    <Form>
                        <div className="form-input">
                            <Form.Control isValid={addGcashTransData != undefined} isInvalid={addGcashTransMessage !== undefined} onChange={onRefChange} className="ref" placeholder="Ref.No" />
                            {addGcashTransMessage !== undefined && <div className="invalid-feedback">{t('txt20')}</div>}
                            {addGcashTransData !== undefined && <Form.Control.Feedback>{t('txt18')}</Form.Control.Feedback>}

                        </div>
                        <Button onClick={() => onAddTransaction()} className="sbt" type="button">{t('txt14')}</Button>
                    </Form>


                    <div className="attention">
                        <div className="title">{t('txt15')}</div>
                        <div className="item">
                            <Trans
                                i18nKey={'txt16'}
                                ns="translations"
                                values={{ userid: userData.userid }}
                                components={{
                                    userid: <span />
                                }}
                            />
                        </div>
                        <div className="item">{t('txt17')}</div>
                    </div>
                </div>


            </Container>
        </>
    )
}

export default Gcash